// export default ProductMap = {
exports.ProductMap = {
  9: {
    '2kWh': [{
      name: 'スターターキット (2kWh)',
      pid: '7415322345633',
      varId: '42082797813921',
      adaptBatCap: 2,
      limit: 2,
      off_price: '572000',
      old_price: '572000',
      // save_money: '0',
      imgSrc: '/img/mm100/preview/setkit-2kw.jpg',
      delivery_date: '9月上旬',
      accessories: ['EcoFlow パワーハブ x1', 'EcoFlow パワーシステム専用2kWh LFPバッテリー x1', 'EcoFlow パワーハブ専用ケーブルセット x1'],
      detailImgList: ['power-2kw.jpg', 'wire.jpg'],
      desc: 'スターターキットには、LFPバッテリーとパワーハブが含まれます。RV車やオフグリッド住宅の基本となる電源システムをスピーディーに構築したい方におすすめのセットです。'
    }, {
      name: 'セミコンプリートキット (2kWh)',
      pid: '7415322345633',
      varId: '42082797846689',
      adaptBatCap: 2,
      limit: 2,
      off_price: '638000',
      old_price: '638000',
      // save_money: '0',
      imgSrc: '/img/mm100/preview/prekit-2kw.jpg',
      delivery_date: '9月上旬',
      accessories: ['EcoFlow パワーハブ x1', 'EcoFlow パワーシステム専用2kWh LFPバッテリー x1', 'EcoFlow パワーハブ専用ケーブルセット x1', 'EcoFlow パワーシステム専用スマート分電盤 x1', '2kWh LFPバッテリー固定用バンド x1'],
      detailImgList: ['bundle-2kw-dp.jpg', 'wire.jpg'],
      desc: 'キャンピングカーで長時間過ごしたり、オフグリッドを中心とした暮らしをお考えの方に最適なセットです。セミコンプリートキットがあれば、より快適で自由に電力を使用できるようになります。'
    }, {
      name: 'コンプリートキット (2kWh)',
      pid: '7415322345633',
      varId: '42082797879457',
      adaptBatCap: 2,
      limit: 2,
      off_price: '693000',
      old_price: '693000',
      // save_money: '0',
      imgSrc: '/img/mm100/preview/indkit-2kw-us.jpg',
      delivery_date: '9月上旬',
      accessories: ['EcoFlow パワーハブ x1', 'EcoFlow パワーシステム専用2kWh LFPバッテリー x1', 'EcoFlow パワーハブ専用ケーブルセット x1', 'EcoFlow パワーシステム専用スマート分電盤 x1', 'EcoFlow パワーシステム専用タッチパネルモニター x1',
      // 'スマート発電機 x1',
      '2kWh LFPバッテリー固定用バンド x1'],
      detailImgList: ['bundle-2kw-all_us.jpg', 'wire.jpg'],
      desc: 'コンプリートキットは、RVやオフグリッドシステムの構築に必要なモジュールがすべて揃った豪華パッケージです。このコンプリートキットに含まれるスマート分電盤とタッチパネルモニターがあれば、電力の制御・モニタリング・カスタマイズが可能です。'
    }],
    '4kWh': [{
      name: 'スターターキット (4kWh)',
      pid: '7415322411169',
      varId: '42082798108833',
      adaptBatCap: 2,
      limit: 1,
      off_price: '792000',
      old_price: '792000',
      // save_money: '0',
      imgSrc: '/img/mm100/preview/setkit-4kw.jpg',
      delivery_date: '9月上旬',
      accessories: ['EcoFlow パワーハブ x1', 'EcoFlow パワーシステム専用2kWh LFPバッテリー x2', 'EcoFlow パワーハブ専用ケーブルセット x1'],
      detailImgList: ['power-4kw.jpg', 'wire.jpg'],
      desc: 'スターターキットには、LFPバッテリーとパワーハブが含まれます。RV車やオフグリッド住宅の基本となる電源システムをスピーディーに構築したい方におすすめのセットです。'
    }, {
      name: 'セミコンプリートキット (4kWh)',
      pid: '7415322411169',
      varId: '42082798141601',
      adaptBatCap: 2,
      limit: 1,
      off_price: '880000',
      old_price: '880000',
      // save_money: '0',
      imgSrc: '/img/mm100/preview/prekit-4kw.jpg',
      delivery_date: '9月上旬',
      accessories: ['EcoFlow パワーハブ x1', 'EcoFlow パワーシステム専用2kWh LFPバッテリー x2', 'EcoFlow パワーハブ専用ケーブルセット x1', 'EcoFlow パワーシステム専用スマート分電盤 x1', '2kWh LFPバッテリー固定用バンド x2'],
      detailImgList: ['bundle-4kw-dp.jpg', 'wire.jpg'],
      desc: 'キャンピングカーで長時間過ごしたり、オフグリッドを中心とした暮らしをお考えの方に最適なセットです。セミコンプリートキットがあれば、より快適で自由に電力を使用できるようになります。'
    }, {
      name: 'コンプリートキット (4kWh)',
      pid: '7415322411169',
      varId: '42082798174369',
      adaptBatCap: 2,
      limit: 1,
      off_price: '924000',
      old_price: '924000',
      // save_money: '0',
      imgSrc: '/img/mm100/preview/indkit-4kw-us.jpg',
      delivery_date: '9月上旬',
      accessories: ['EcoFlow パワーハブ x1', 'EcoFlow パワーシステム専用2kWh LFPバッテリー x2', 'EcoFlow パワーハブ専用ケーブルセット x1', 'EcoFlow パワーシステム専用スマート分電盤 x1', 'EcoFlow パワーシステム専用タッチパネルモニター x1',
      // 'スマート発電機 x1',
      '2kWh LFPバッテリー固定用バンド x2'],
      detailImgList: ['bundle-4kw-all_us.jpg', 'wire.jpg'],
      desc: 'コンプリートキットは、RVやオフグリッドシステムの構築に必要なモジュールがすべて揃った豪華パッケージです。このコンプリートキットに含まれるスマート分電盤とタッチパネルモニターがあれば、電力の制御・モニタリング・カスタマイズが可能です。'
    }],
    '5kWh': [{
      name: 'スターターキット (5kWh)',
      pid: '7415322673313',
      varId: '42082801680545',
      adaptBatCap: 5,
      limit: 2,
      off_price: '858000',
      old_price: '858000',
      // save_money: '0',
      imgSrc: '/img/mm100/preview/setkit-5kw.jpg',
      delivery_date: '9月上旬',
      accessories: ['EcoFlow パワーハブ x1', 'EcoFlow パワーシステム専用5kWh LFPバッテリー x1', 'EcoFlow パワーハブ専用ケーブルセット x1'],
      detailImgList: ['power-5kw.jpg', 'wire.jpg'],
      desc: 'スターターキットには、LFPバッテリーとパワーハブが含まれます。RV車やオフグリッド住宅の基本となる電源システムをスピーディーに構築したい方におすすめのセットです。'
    }, {
      name: 'セミコンプリートキット (5kWh)',
      pid: '7415322673313',
      varId: '42082801713313',
      adaptBatCap: 5,
      limit: 2,
      off_price: '935000',
      old_price: '935000',
      // save_money: '0',
      imgSrc: '/img/mm100/preview/prekit-5kw.jpg',
      delivery_date: '9月上旬',
      accessories: ['EcoFlow パワーハブ x1', 'EcoFlow パワーシステム専用5kWh LFPバッテリー x1', 'EcoFlow パワーハブ専用ケーブルセット x1', 'EcoFlow パワーシステム専用スマート分電盤 x1', '5kWh LFPバッテリー固定用バンド x1'],
      detailImgList: ['bundle-5kw-dp.jpg', 'wire.jpg'],
      desc: 'キャンピングカーで長時間過ごしたり、オフグリッドを中心とした暮らしをお考えの方に最適なセットです。セミコンプリートキットがあれば、より快適で自由に電力を使用できるようになります。'
    }, {
      name: 'コンプリートキット (5kWh)',
      pid: '7415322673313',
      varId: '42082801746081',
      adaptBatCap: 5,
      limit: 2,
      off_price: '979000',
      old_price: '979000',
      // save_money: '0',
      imgSrc: '/img/mm100/preview/indkit-5kw-us.jpg',
      delivery_date: '9月上旬',
      accessories: ['EcoFlow パワーハブ x1', 'EcoFlow パワーシステム専用5kWh LFPバッテリー x1', 'EcoFlow パワーハブ専用ケーブルセット x1', 'EcoFlow パワーシステム専用スマート分電盤 x1', 'EcoFlow パワーシステム専用タッチパネルモニター x1',
      // 'スマート発電機 x1',
      '5kWh LFPバッテリー固定用バンド x1'],
      detailImgList: ['bundle-5kw-all_us.jpg', 'wire.jpg'],
      desc: 'コンプリートキットは、RVやオフグリッドシステムの構築に必要なモジュールがすべて揃った豪華パッケージです。このコンプリートキットに含まれるスマート分電盤とタッチパネルモニターがあれば、電力の制御・モニタリング・カスタマイズが可能です。'
    }],
    '10kWh': [{
      name: 'スターターキット (10kWh)',
      pid: '7415321526433',
      varId: '42082785099937',
      adaptBatCap: 5,
      limit: 1,
      off_price: '1375000',
      old_price: '1375000',
      // save_money: '0',
      imgSrc: '/img/mm100/preview/setkit-10kw.jpg',
      delivery_date: '9月上旬',
      accessories: ['EcoFlow パワーハブ x1', 'EcoFlow パワーシステム専用5kWh LFPバッテリー x2', 'EcoFlow パワーハブ専用ケーブルセット x1'],
      detailImgList: ['power-10kw.jpg', 'wire.jpg'],
      desc: 'スターターキットには、LFPバッテリーとパワーハブが含まれます。RV車やオフグリッド住宅の基本となる電源システムをスピーディーに構築したい方におすすめのセットです。'
    }, {
      name: 'セミコンプリートキット (10kWh)',
      pid: '7415321526433',
      varId: '42082785165473',
      adaptBatCap: 5,
      limit: 1,
      off_price: '1452000',
      old_price: '1452000',
      // save_money: '0',
      imgSrc: '/img/mm100/preview/prekit-10kw.jpg',
      delivery_date: '9月上旬',
      accessories: ['EcoFlow パワーハブ x1', 'EcoFlow パワーシステム専用5kWh LFPバッテリー x2', 'EcoFlow パワーハブ専用ケーブルセット x1', 'EcoFlow パワーシステム専用スマート分電盤 x1', '5kWh LFPバッテリー固定用バンド x2'],
      detailImgList: ['bundle-10kw-dp.jpg', 'wire.jpg'],
      desc: 'キャンピングカーで長時間過ごしたり、オフグリッドを中心とした暮らしをお考えの方に最適なセットです。セミコンプリートキットがあれば、より快適で自由に電力を使用できるようになります。'
    }, {
      name: 'コンプリートキット (10kWh)',
      pid: '7415321526433',
      varId: '42082785198241',
      adaptBatCap: 5,
      limit: 1,
      off_price: '1507000',
      old_price: '1507000',
      // save_money: '0',
      imgSrc: '/img/mm100/preview/indkit-10kw-us.jpg',
      delivery_date: '9月上旬',
      accessories: ['EcoFlow パワーハブ x1', 'EcoFlow パワーシステム専用5kWh LFPバッテリー x2', 'EcoFlow パワーハブ専用ケーブルセット x1', 'EcoFlow パワーシステム専用スマート分電盤 x1', 'EcoFlow パワーシステム専用タッチパネルモニター x1',
      // 'スマート発電機 x1',
      '5kWh LFPバッテリー固定用バンド x2'],
      detailImgList: ['bundle-10kw-all_us.jpg', 'wire.jpg'],
      desc: 'コンプリートキットは、RVやオフグリッドシステムの構築に必要なモジュールがすべて揃った豪華パッケージです。このコンプリートキットに含まれるスマート分電盤とタッチパネルモニターがあれば、電力の制御・モニタリング・カスタマイズが可能です。'
    }],
    '15kWh': [{
      name: 'スターターキット (15kWh)',
      pid: '7415322312865',
      varId: '42082797289633',
      off_price: '1903000',
      old_price: '1903000',
      // save_money: '0',
      imgSrc: '/img/mm100/preview/setkit-15kw.jpg',
      delivery_date: '9月上旬',
      accessories: ['EcoFlow パワーハブ x1', 'EcoFlow パワーシステム専用5kWh LFPバッテリー x3', 'EcoFlow パワーハブ専用ケーブルセット x1'],
      detailImgList: ['power-15kw.jpg', 'wire.jpg'],
      desc: 'スターターキットには、LFPバッテリーとパワーハブが含まれます。RV車やオフグリッド住宅の基本となる電源システムをスピーディーに構築したい方におすすめのセットです。'
    }, {
      name: 'セミコンプリートキット (15kWh)',
      pid: '7415322312865',
      varId: '42082797322401',
      off_price: '1980000',
      old_price: '1980000',
      // save_money: '0',
      imgSrc: '/img/mm100/preview/prekit-15kw.jpg',
      delivery_date: '9月上旬',
      accessories: ['EcoFlow パワーハブ x1', 'EcoFlow パワーシステム専用5kWh LFPバッテリー x3', 'EcoFlow パワーハブ専用ケーブルセット x1', 'EcoFlow パワーシステム専用スマート分電盤 x1', '5kWh LFPバッテリー固定用バンド x3'],
      detailImgList: ['bundle-15kw-dp.jpg', 'wire.jpg'],
      desc: 'キャンピングカーで長時間過ごしたり、オフグリッドを中心とした暮らしをお考えの方に最適なセットです。セミコンプリートキットがあれば、より快適で自由に電力を使用できるようになります。'
    }, {
      name: 'コンプリートキット (15kWh)',
      pid: '7415322312865',
      varId: '42082797355169',
      off_price: '2035000',
      old_price: '2035000',
      // save_money: '0',
      imgSrc: '/img/mm100/preview/indkit-15kw-us.jpg',
      delivery_date: '9月上旬',
      accessories: ['EcoFlow パワーハブ x1', 'EcoFlow パワーシステム専用5kWh LFPバッテリー x3', 'EcoFlow パワーハブ専用ケーブルセット x1', 'EcoFlow パワーシステム専用スマート分電盤 x1', 'EcoFlow パワーシステム専用タッチパネルモニター x1',
      // 'スマート発電機 x1',
      '5kWh LFPバッテリー固定用バンド x3'],
      detailImgList: ['bundle-15kw-all_us.jpg', 'wire.jpg'],
      desc: 'コンプリートキットは、RVやオフグリッドシステムの構築に必要なモジュールがすべて揃った豪華パッケージです。このコンプリートキットに含まれるスマート分電盤とタッチパネルモニターがあれば、電力の制御・モニタリング・カスタマイズが可能です。'
    }]
  }
};
exports.solarPanelMap = {
  9: [{
    name: 'EcoFlow 100W据置型ソーラーパネル(剛性)*2＋据置型ソーラーパネル(剛性)固定用マウント*2',
    pid: '7415329685665',
    varId: '42082928623777',
    old_price: '34100',
    off_price: '34100',
    // save_money: '0',
    limit: 99,
    imgSrc: '/img/mm100/preview/rigid-100w.jpg'
  }, {
    name: 'EcoFlow 400W据置型ソーラーパネル(剛性)*2+据置型ソーラーパネル(剛性)固定用マウント*4',
    pid: '7415330046113',
    varId: '42082933276833',
    old_price: '140800',
    off_price: '140800',
    // save_money: '0',
    // tips: "*This item excludes free shipping.",
    limit: 99,
    imgSrc: '/img/mm100/preview/rigid-400w.jpg'
  }, {
    name: 'EcoFlow 100W据置型ソーラーパネル(柔性)',
    pid: '7415550673057',
    varId: '42084267425953',
    old_price: '17490',
    off_price: '17490',
    // save_money: '0',
    limit: 99,
    imgSrc: '/img/mm100/preview/flexibel-100w.jpg'
  }, {
    name: '400Wソーラーパネル(折りたたみ式）',
    pid: '7148022431905',
    varId: '41282474836129',
    old_price: '126500',
    off_price: '126500',
    // save_money: '0',
    limit: 99,
    imgSrc: '/img/mm100/preview/flexibel-400w.jpg'
  }]
};
exports.BatteryMap = {
  9: [{
    name: 'EcoFlow パワーシステム専用2kWh LFPバッテリー',
    pid: '7415322345633',
    varId: '42082920136865',
    off_price: '242000',
    old_price: '242000',
    // save_money: '0',
    capacity: 2,
    imgSrc: '/img/mm100/preview/battery-2kw.jpg'
  }, {
    name: 'EcoFlow パワーシステム専用5kWh LFPバッテリー',
    pid: '7415322673313',
    varId: '42082920169633',
    off_price: '550000',
    old_price: '550000',
    // save_money: '0',
    capacity: 5,
    imgSrc: '/img/mm100/preview/battery-5kw.jpg'
  }]
};
exports.InstallationMap = {
  9: {}
};
exports.ConsoleMap = {
  9: []
};
exports.ShopifyUrl = 'https://jp.ecoflow.com/';